import React from 'react';
import ReactDOM from 'react-dom';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
var num = require('numeral');

const fmt = require('../zero/fmt.js');
const isTrue = fmt.coerceBoolean;

@observer
export default class BorrowerLookupApp extends React.Component {
	render() {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<img className="logo" src="img/logo_2023_large.png" />
					</div>
				</div>

				<div className="row top-menu">
					<div className="col-md-12">
						&nbsp;
					</div>
				</div>

				<BorrowerLookup store={this.props.store} />

				<div className="row margin-top">
					<div className="col-md-12">
						<hr />

						<p className="text-center text-muted">
							This site is for informational purposes and is for use by licensed industry professionals.
							<br />
							This site and the information contained therein is not a solicitation to lend money to consumers.
						</p>

						<p className="text-center text-muted">
							CBC Mortgage Agency NMLS: 1186381 - 912 W. Baxter Drive, Suite 150 South Jordan, Utah 84095
							<br />
							Main 866-563-3507
							|
							Servicing 866-563-7572
							|
							Fax 435-237-0022
						</p>

						<p className="text-center text-muted">
							© 2018. All Rights Reserved.
						</p>
					</div>
				</div>
			</div>
		)
	}
}

class BorrowerLookupStore {
	@observable loanNumberInput = '';
	@observable ssnLast4Input = '';
	@observable propertyZipInput = '';

	@observable loan = null;

	@observable notFound = false;

	@observable serverError = null;

	sendBorrowerLookupRequest() {
		$.ajax({
			url: '/app/borrowerLookup',
			method: 'POST',
			data: {
				cbcLoanNum: this.loanNumberInput,
				borrowerSsnLast4: this.ssnLast4Input,
				propertyZip: this.propertyZipInput
			},
			error: (xhr, status, error) => {
				this.serverError = error;
			},
			success: (response) => {
				if (response.notFound) {
					this.notFound = true;
				}
				else {
					this.notFound = false;
					this.loan = response.loan;
				}
			}
		})
	}
}

@observer
class PaymentHistory extends React.Component {

	renderPayment() {
		let loan = this.props.loan;

		let runningUpb
		if (loan.loantype === "HFH")
			runningUpb = fmt.coerceFloat(loan.hfhCurrenUpb);
		else
			runningUpb = fmt.coerceFloat(loan.loanVisionUPB);

		let runningEscrowAmount
		runningEscrowAmount = fmt.coerceFloat(loan.netEscrowPurchase)

		if (loan.paymentRecord && loan.paymentRecord.length > 0) {

			let temp = loan.paymentRecord.sort((a, b) => {
				return a.prPaymentDueDate.localeCompare(b.prPaymentDueDate);
			});

			return temp.map((p, index) => {
				// returnValue = returnValue + `<tr><td class=\"text-left\" style=\"border:2px solid\">${fmt.shortDate(p.prPaymentDueDate)}</td><td class=\"text-left\" style=\"border:2px solid\">${fmt.shortDate(p.prMadeDate)}</td><td class=\"text-left\" style=\"border:2px solid\">${p.prPaymentSource}</td><td class=\"text-left\" style=\"border:2px solid\">${fmt.smallUSD(fmt.coerceFloat(p.prPrincipalAmount) + fmt.coerceFloat(p.prInterestAmount) + fmt.coerceFloat(p.prEscrowAmount))}</td><td class=\"text-left\" style=\"border:2px solid\">${fmt.smallUSD(p.prPrincipalAmount)}</td><td class=\"text-left\" style=\"border:2px solid\">${fmt.smallUSD(p.prEscrowAmount)}</td><td class=\"text-left\" style=\"border:2px solid\">${fmt.smallUSD(runningUpb)}</td><td class=\"text-left\" style=\"border:2px solid\">${fmt.smallUSD(runningEscrowAmount)}</td></tr>`;

				return (<tr key={index}>
					<td className="text-left" style={{ border: '2px', 'borderStyle': 'solid' }}>{p.prPaymentDueDate}</td>
					<td className="text-left" style={{ border: '2px', 'borderStyle': 'solid' }}>{p.prMadeDate}</td>
					<td className="text-left" style={{ border: '2px', 'borderStyle': 'solid' }}>{fmt.smallUSD(p.prPrincipalAmount)}</td>
					<td className="text-left" style={{ border: '2px', 'borderStyle': 'solid' }}>{fmt.smallUSD(p.prEscrowAmount)}</td>
					<td className="text-left" style={{ border: '2px', 'borderStyle': 'solid' }}>{fmt.smallUSD(p.prInterestAmount)}</td>
					<td className="text-left" style={{ border: '2px', 'borderStyle': 'solid' }}>{fmt.smallUSD(fmt.coerceFloat(p.prPrincipalAmount) + fmt.coerceFloat(p.prInterestAmount) + fmt.coerceFloat(p.prEscrowAmount))}</td>
				</tr>)
			})
		}
	}

	render() {

		return (
			<div>
				<div className="col text-center text-primary"><h4>Payment History</h4></div>
				<table className="table">
					<thead className="thead-default">
						<tr>
							<th className="col-xs-2 text-left text-primary" style={{ border: '2px', 'borderStyle': 'solid', 'borderColor': 'black' }}>Payment Due</th>
							<th className="col-xs-2 text-left text-primary" style={{ border: '2px', 'borderStyle': 'solid', 'borderColor': 'black' }}>Payment Made</th>
							<th className="col-xs-1 text-left text-primary" style={{ border: '2px', 'borderStyle': 'solid', 'borderColor': 'black' }}>Principal</th>
							<th className="col-xs-1 text-left text-primary" style={{ border: '2px', 'borderStyle': 'solid', 'borderColor': 'black' }}>Escrow</th>
							<th className="col-xs-1 text-left text-primary" style={{ border: '2px', 'borderStyle': 'solid', 'borderColor': 'black' }}>Interest</th>
							<th className="col-xs-1 text-left text-primary" style={{ border: '2px', 'borderStyle': 'solid', 'borderColor': 'black' }}>Payment Total</th>
						</tr>
					</thead>
					<tbody>
						{this.renderPayment()}
					</tbody>
				</table>
			</div>
		)
	}

}

@observer
class BorrowerLookup extends React.Component {
	submit(e) {
		e.preventDefault();
		this.props.store.sendBorrowerLookupRequest();
	}

	render() {
		let { store } = this.props;

		return (
			<div>
				<div className="row margin-top">
					<div className="col-md-12">
						<p>CBC Mortgage Agency is happy to provide you with a second mortgage to make the purchase of your new home possible. In addition, CBC Mortgage Agency also purchased your first mortgage.  We will only hold your first mortgage for a very short period and will soon transfer it to another lender, but we will continue to hold your second mortgage.</p>
					</div>
				</div>
				{
					!store.loan ? (
						<div className="row margin-top">
							<div className="col-md-12">
								<form className="form-inline" onSubmit={e => this.submit(e)}>
									<input type="text" className="form-control" placeholder="Loan Number" value={store.loanNumberInput} onChange={e => store.loanNumberInput = e.target.value} />
									{' '}
									<input type="text" className="form-control" placeholder="Last 4 of SSN" value={store.ssnLast4Input} onChange={e => store.ssnLast4Input = e.target.value} />
									{' '}
									<input type="text" className="form-control" placeholder="Property Zip Code" value={store.propertyZipInput} onChange={e => store.propertyZipInput = e.target.value} />
									{' '}
									<button type="submit" className="btn btn-primary">Submit</button>
								</form>
							</div>
							<div className="col-md-12">
								<p><br /><b>For security and privacy reasons, we ask for three identifying pieces of information.</b></p>
							</div>
						</div>
					) : null
				}
				{
					store.notFound ? (
						<div className="row margin-top">
							<div className="col-md-12">
								<div className="alert alert-danger">
									We could not find that loan. Please double-check the information that you provided and try again.
								</div>
							</div>
						</div>
					) : null
				}
				{
					store.loan ? (
						<div>
							{
								(store.loan.dpaType === "Gift" || store.loan.dpaType === "Soft Second") ? (
									null
								) : (
									<h4>You have a 1st mortgage and a 2nd mortgage. Two Payments are required, as listed below: </h4>
								)
							}
							<div className="row margin-top">
								<div className="col-md-6">
									<h3>Primary Mortgage</h3>
									<BorrowerLookupPrimaryMortgage key='pm' loan={store.loan} />
								</div>
								<div className="col-md-6">
									<h3>Second Mortgage</h3>
									<BorrowerLookupSecondMortgage key='sm' loan={store.loan} />
								</div>
							</div>
						</div>
					) : (
						<div className="row margin-top" style={{ height: 100 }}>
						</div>
					)
				}
			</div>
		)
	}
}

let BorrowerLookupPrimaryMortgage = ({ loan }) => {

	//Due Date Section
	let cbcDueDate = (isTrue(loan.paymentExpected) && !loan.interimPaymentRecDate && loan.nextPaymentDueDate) ? moment(loan.nextPaymentDueDate).format("MMM-DD-YYYY") : '';
	let invDueDate = loan.tPaymentDueSec ? moment(loan.tPaymentDueSec).format("MMM-DD-YYYY") : '';

	const displayMessage = "Please reach out to CBC Mortgage Agency's Servicing Team to discuss your upcoming payment.  They can be reached by phone toll free at (866) 563-7572 Monday through Friday 8:00 AM to 5:00 PM MST.  You can also contact our Servicing Team by email at: servicing@chenoafund.org."
	const paymentUrl = 'https://portal-login.willowservicing.com/u/login';

	var dueDateBlock1
	let onlinePaymentDisplay
	if (cbcDueDate) {
		dueDateBlock1 = <span key='pdue'>Your payment is due to:</span>;
		onlinePaymentDisplay = <span><br /><br />Make your payment online <a href={paymentUrl} target="_blank">here</a></span>
		// onlinePaymentDisplay = <i><br/><br/>Contact CBC Mortgage Agency To Make Your Payment</i>;
	}
	else if (isTrue(loan.paymentExpected) && !loan.nextPaymentDueDate)
		dueDateBlock1 = <span key='pdue'>{displayMessage}</span>;
	else if (invDueDate) {
		dueDateBlock1 = <span key='pdue'>Your payment is due to:</span>;
	}
	else
		dueDateBlock1 = <span key='pdue'>{displayMessage}</span>;

	let dueDateBlock2
	if ((cbcDueDate || (isTrue(loan.paymentExpected) && !loan.nextPaymentDueDate)) && invDueDate)
		dueDateBlock2 = <span key='pdue'>Your <b>{invDueDate}</b> payment is due to:</span>;

	//Correspondent Section
	var corrName = loan.orgName;
	var corrBlock = [];
	corrBlock.push(<span key='corrName'><br /><b>{corrName}</b></span>);
	corrBlock.push(<span key='coupon'><br />Payment coupon should be in your closing papers.</span>);

	//CBC Section
	var orgName = 'CBC Mortgage Agency';
	var addressLine1 = '912 W Baxter Drive, Suite 150';
	var addressLine2 = 'South Jordan, UT 84095';
	var paymentPhone = '866-563-7572';
	var cbcLoanNum = loan.cbcLoanNum;
	var origLoanNum = loan.loLoanNum;
	var cbcBlock = [];
	cbcBlock.push(<span key='orgName'><br /><b>{orgName}</b></span>);
	cbcBlock.push(<span key='addr'><br />{addressLine1}<br />{addressLine2}<br />{paymentPhone}<br />Loan #:{cbcLoanNum}<br />Other Investor Loan Number: {origLoanNum}{onlinePaymentDisplay}</span>);


	//Investor Section
	var invName;
	var invAddressLine1;
	var invAddressLine2;
	var invPaymentPhone;
	var invBlock = [];
	invBlock.push(<span><br /></span>);

	//PUF
	if (loan.investor === 'PUF') {
		invName = 'Pacific Union Financial, LLC';
		invAddressLine1 = 'P.O. Box 655621';
		invAddressLine2 = 'Dallas, TX  75265-5621';
		invPaymentPhone = '877-516-7998';
	}
	// M&T
	else if (loan.investor === 'M&T') {
		invName = 'M&T Bank';
		invAddressLine1 = 'P.O. Box 62182';
		invAddressLine2 = 'Baltimore, MD  21264-2182';
		invPaymentPhone = '800-724-2224';
	}
	// LLN
	else if (loan.investor === 'LLN') {
		invName = 'Specialized Loan Servicing LLC';
		invAddressLine1 = 'P.O. Box 105219';
		invAddressLine2 = 'Atlanta, GA 30348-5219';
		invPaymentPhone = '800-315-4757';
	}
	// CAS
	else if (loan.investor === 'CAS') {
		invName = 'Castle Mortgage Corporation';
		invAddressLine1 = 'P.O. Box 37628';
		invAddressLine2 = 'Philadelphia, PA  19101-0628';
		invPaymentPhone = '800-274-6600';
	}
	// USF
	else if (loan.investor === 'USF') {
		invName = 'RoundPoint Mortgage Servicing Corp';
		invAddressLine1 = '4400 Amon Carter, Suite 110';
		invAddressLine2 = 'Forth Worth, TX  76155';
		invPaymentPhone = '877 426-8805';
	}
	// PHM
	else if (loan.investor === 'PHM') {
		invName = 'Plaza Home Mortgage, Inc.';
		invAddressLine1 = '1 Corporate Drive, Suite #360';
		invAddressLine2 = 'Lake Zurich, IL  60047-8945';
		invPaymentPhone = '877-801-2445';
	}
	// TMS
	else if (loan.investor === 'TMS') {
		invName = 'The Money Source Inc.';
		invAddressLine1 = 'P.O. Box 650094';
		invAddressLine2 = 'Dallas, TX  75265-0094';
		invPaymentPhone = '866-867-0330';
	}
	// 360
	else if (loan.investor === '360') {
		orgName = '360 Mortgage Group, LLC';
		invAddressLine1 = 'P.O. Box 679047';
		invAddressLine2 = 'Dallas, TX 75267-9047';
		invPaymentPhone = '866-360-4636';
	}
	// INT
	else if (loan.investor === 'INT') {
		invName = 'Intercap Lending Inc.';
		invAddressLine1 = 'PO BOX 300';
		invAddressLine2 = 'Albuquerque, NM 87103';
		invPaymentPhone = '385-800-8440';
	}
	// INT
	else if (loan.investor === 'FST') {
		invName = 'Flagstar Bank, FSB';
		invAddressLine1 = 'P.O. Box 660263';
		invAddressLine2 = 'Dallas, TX 75266-0263';
		invPaymentPhone = '800-968-7700';
	}
	// MRC
	else if (loan.investor === 'MRC') {
		invName = 'Nationstar Mortgage LLC dba Mr. Cooper';
		invAddressLine1 = '8950 Cypress Waters Blvd.';
		invAddressLine2 = 'Coppell, TX  75019';
		invPaymentPhone = '855-430-8490';
	}
	// NPT
	else if (loan.investor === 'NPT') {
		invName = 'Northpointe Bank';
		invAddressLine1 = '3333 Deposit Dr NE';
		invAddressLine2 = 'Grand Rapids, MI 49546';
		invPaymentPhone = '866-418-7180';
	}
	// DMI
	else if (loan.investor === 'DMI') {
		invName = 'Data Mortgage Inc.';
		invAddressLine1 = '2200 W. Orangewood Ave, Suite 150';
		invAddressLine2 = 'Orange, CA 92868';
		invPaymentPhone = '714-935-2581';
	}
	// CMG
	else if (loan.investor === 'CMG') {
		invName = 'CMG';
		invAddressLine1 = '3160 Crow Canyon Road';
		invAddressLine2 = 'San Ramon, CA 94583';
		invPaymentPhone = '925-884-2709';
	}
	// ESX
	else if (loan.investor === 'ESX' || loan.tPaymentDueSec) {
		invName = 'Essex Mortgage';
		invAddressLine1 = 'P.O. Box 105178';
		invAddressLine2 = 'Atlanta, GA 30348-5178';
		invPaymentPhone = '855-748-2722';
	}
	// PLZ
	else if (loan.investor === 'PLZ') {
		invName = 'Plaza Home Mortgage, Inc.';
		invAddressLine1 = 'P.O. Box 371458';
		invAddressLine2 = 'Pittsburgh, PA 15250-7458';
		invPaymentPhone = '858-346-1208';
	}
	// GNM
	else if (loan.investor === 'GNM') {
		invName = 'Nationstar Mortgage LLC d/b/a Mr. Cooper';
		invAddressLine1 = 'PO Box 650783';
		invAddressLine2 = 'Dallas, Texas 75265-0783';
		invPaymentPhone = '877-372-0512';
	}
	else if (loan.investor === 'CTL') {
		invName = 'Castle Mortgage';
		invAddressLine1 = '5414 Oberlin Drive, Suite 375';
		invAddressLine2 = 'San Diego, CA 92121';
		invPaymentPhone = '858-207-4256';
	}
	else if (loan.investor === 'PHH') {
		invName = 'PHH Mortgage';
		invAddressLine1 = 'P.O. Box 94087';
		invAddressLine2 = 'Palatine, IL 60094-4087';
		invPaymentPhone = '(800) 449-8767';
	}
	else {
		invName = 'INVESTOR MISSING';
		invAddressLine1 = '123 Place';
		invAddressLine2 = 'SLC, UT 84117';
		invPaymentPhone = '(801) 123-1234';
	}

	var invLoanNum = 'Loan Number: COMING SOON';
	invBlock.push(<span><b>{invName}</b><br />{invAddressLine1}<br />{invAddressLine2}<br />{invPaymentPhone}<br />{invLoanNum}</span>);

	//Payment Block Section
	var payment1Block;
	var payment2Block;
	//var payment3Block;

	if (loan.firstPaymentTo === 'CBCMA' || cbcDueDate || (isTrue(loan.paymentExpected) && !loan.nextPaymentDueDate)) {
		payment1Block = cbcBlock;
	}
	// logic to support date field driven display, per Mat L.
	else if (loan.firstPaymentTo === 'Investor' || invDueDate) { payment1Block = invBlock; }
	else if (loan.firstPaymentTo === 'Correspondent') { payment1Block = corrBlock; }
	else { payment1Block = cbcBlock; }

	if (loan.secondPaymentTo === 'CBCMA') { payment2Block = cbcBlock; }
	// logic to support date field driven display, per Mat L.
	else if (loan.secondPaymentTo === 'Investor' || ((cbcDueDate || (isTrue(loan.paymentExpected) && !loan.nextPaymentDueDate)) && invDueDate)) {
		payment2Block = invBlock;
	}
	else if (loan.secondPaymentTo === 'Correspondent') { payment2Block = corrBlock; }

	// Only 2 potential payment blocks, per Mat L.
	// if (loan.thirdPaymentTo === 'CBCMA') { payment3Block = cbcBlock; }
	// else if (loan.thirdPaymentTo === 'Investor') { payment3Block = invBlock; }
	// else if (loan.thirdPaymentTo === 'Correspondent') { payment3Block = corrBlock; }

	// Loan Details Block
	var interestRate = loan.interestRate;

	var pAndI;
	if (loan.pAndI) { pAndI = loan.pAndI } else { pAndI = "0.00"; }

	var taxes;
	if (loan.taxesPortion) { taxes = loan.taxesPortion } else { taxes = "0.00"; }

	var insurance;
	if (loan.insurancePortion) { insurance = loan.insurancePortion } else { insurance = "0.00"; }

	var mortgageInsurance;
	if (loan.mortgageInsurancePortion) { mortgageInsurance = loan.mortgageInsurancePortion } else { mortgageInsurance = "0.00"; }

	var pitimi;
	if (loan.pitimi) { pitimi = loan.pitimi } else { pitimi = "0.00"; }

	var totalMortPmt;
	totalMortPmt = fmt.smallUSD(fmt.coerceFloat(pAndI) + fmt.coerceFloat(taxes) + fmt.coerceFloat(insurance) + fmt.coerceFloat(mortgageInsurance));

	var totalloan = fmt.smallUSD(loan.totalLoan);

	pAndI = fmt.smallUSD(pAndI);
	taxes = fmt.smallUSD(taxes);
	insurance = fmt.smallUSD(insurance);
	mortgageInsurance = fmt.smallUSD(mortgageInsurance);

	return (
		<div>
			<b>Loan Details</b>
			<br />
			Chenoa Fund Loan Number: {loan.cbcLoanNum}
			<br />
			Other Investor Loan Number: {loan.loLoanNum}
			<br />
			Interest Rate: {interestRate}%
			<br />
			Original Loan Balance: {totalloan}
			<br /><br />
			1st Mortgage P&I Payment = {pAndI}
			<br />
			+ 1st Mortgage Taxes = {taxes}
			<br />
			+ 1st Insurance = {insurance}
			<br />
			+ 1st Mortgage Mortgage Insurance = {mortgageInsurance}
			<br />
			= Total 1st Mortgage Payment = {totalMortPmt}
			<br /><br />
			{dueDateBlock1}
			<br />
			{payment1Block}
			<br /><br />
			{dueDateBlock2}
			<br />
			{payment2Block}
			<br /><br />
			For general non-servicing related inquiries please call our main number 866-563-3507.
			<br /><br />
		</div>
	)
}

let BorrowerLookupSecondMortgage = ({ loan }) => {

	var displayBlock = [];

	var feedbackUrl = 'http://chenoafund.org/feedback';
	var email = 'servicing@chenoafund.org';

	if (!loan.cbcLoanNum.includes("HFH")) {
		if (loan.dpaType === "Gift") {
			displayBlock.push(<span>The down payment assistance you received was a gift. No repayment is required. Congratulations!<br />Please submit a review <a href={feedbackUrl}>here</a>.</span>);
		}
		else if (loan.dpaType === "Soft Second") {
			/*
			displayBlock.push(<span key='1'>The 2nd mortgage loan requires no payments, and is forgiven after 36 months or 120 months of consecutive<br/></span>);
			displayBlock.push(<span key='2'>on time payments (defined as no more than 29 days past the due date) have been made to your<br/></span>);
			displayBlock.push(<span key='3'>1st mortgage loan servicer. You will be asked to provide a pay history from your mortgage<br/></span>);
			displayBlock.push(<span key='4'>loan servicer to demonstrate the payments have been made in a timely manner. The cost of the<br/></span>);
			displayBlock.push(<span key='5'>reconveyance will be determined by the original closing entity or an acceptable substitute.<br/></span>);
			displayBlock.push(<span key='6'>reconveyance will be determined by the original closing entity or an acceptable substitute.<br/></span>);
			displayBlock.push(<span key='7'>The Note holder may add a processing fee of no more than $50 to cover the costs of processing<br/></span>);
			displayBlock.push(<span key='8'>the release. Documentation may be sent to <a href={'mailto:' + email}>{email}</a>.<br/></span>);*/
			displayBlock.push(<span key='1'>The 2nd mortgage loan requires no payments and is forgiven after either 36 months or 120 months<br /></span>);
			displayBlock.push(<span key='2'>of consecutive on time payments on the 1st mortgage depending on what type of program was used.<br /></span>);
			displayBlock.push(<span key='3'>On time payments are defined as no more than 29 days past the due date. You will be asked to<br /></span>);
			displayBlock.push(<span key='4'>provide a pay history from your mortgage loan servicer or a credit report. The cost of reconveyance<br /></span>);
			displayBlock.push(<span key='5'>will depend on your county fees and the noteholder may add a processing fee of no more than $50<br /></span>);
			displayBlock.push(<span key='6'>to cover the costs of processing the release. Documentation may be sent to <a href={'mailto:' + email}>{email}</a>.<br /></span>);
		} else {
			var dueDate;
			if (!loan.secondMortgageFirstPaymentDate) { dueDate = moment(loan.firstPaymentDate).format("MMM-DD-YYYY"); }
			else { dueDate = moment(loan.secondMortgageFirstPaymentDate).format("MMM-DD-YYYY"); }

			var pmtAmount = loan.secondPaymentAmount;

			// Organization Section
			var orgName = 'Midwest Loan Services';
			var orgNameNoAttn = '';
			var addressLine1 = 'P.O. Box 209';
			var addressLine2 = 'Hancock, MI 49930';
			var paymentPhone = '(800) 262-6574';
			var paymentUrl = 'https://www.midwestloanservices.com';
			if (loan.servicedBy === 'CBC Mortgage Agency') {
				orgName = 'CBC Mortgage Agency Attn: Loan Servicing Payments:';
				orgNameNoAttn = 'CBC Mortgage Agency Attn: Loan Servicing Payments:';
				addressLine1 = '912 W Baxter Drive, Suite 150';
				addressLine2 = 'South Jordan, UT 84095';
				paymentPhone = '866-563-7572';
				paymentUrl = 'https://secure.gotobilling.com/gateway/transact.php?x_login=238575&x_show_form=PAYMENT_FORM';
			} else if (loan.servicedBy === 'Statebridge') {
				orgName = 'Statebridge';
				orgNameNoAttn = 'Statebridge';
				addressLine1 = 'P.O. Box 173313';
				addressLine2 = 'Denver, CO 80217-3313';
				paymentPhone = '(866) 466-3360';
				paymentUrl = 'http://www.statebridgecompany.com/make-a-payment/';
			} else if (loan.servicedBy === 'Essex') {
				orgName = 'Essex Mortgage  Attn: Cashiering';
				orgNameNoAttn = 'Essex Mortgage';
				paymentUrl = 'https://EssexMortgage.com/MyAccount'
				paymentPhone = '(888) 892-0881';
				addressLine1 = '1417 N Magnolia Ave';
				addressLine2 = 'Ocala, FL 34475';
			}

			var interestRate;
			var dpaType = String(loan.dpaType || '');

			if (!dpaType) { interestRate = "N/A"; }
			else if (dpaType.startsWith("10 year 0")) { interestRate = "0%"; }
			else if (dpaType.startsWith("30 year 5")) { interestRate = "5%"; }
			else if (dpaType.startsWith("10 year 6")) { interestRate = "6%"; }
			else if (dpaType.startsWith("10 Year 8")) { interestRate = "8%"; }
			else { interestRate = "N/A"; }

			displayBlock.push(<span key='1'>Your payment of <b>${pmtAmount}</b> is due to:<br /></span>);
			displayBlock.push(<span key='2'><b>{orgName}</b><br /><br /></span>);
			displayBlock.push(<span key='4'>Make your payment online <a href={paymentUrl}>here</a>.<br /><br /></span>);
			displayBlock.push(<span key='5'>Make your payment over the phone by calling<br />{paymentPhone}<br /><br /></span>);
			displayBlock.push(<span key='6'>Payment Mailing Address:<br />{addressLine1}<br />{addressLine2}<br /><br /></span>);
			displayBlock.push(<span key='7'>{orgNameNoAttn}<br />Customer Service {paymentPhone}<br /></span>);

		}
	} else {
		var dueDate;
		if (!loan.secondMortgageFirstPaymentDate) { dueDate = moment(loan.firstPaymentDate).format("MMM-DD-YYYY"); }
		else { dueDate = moment(loan.secondMortgageFirstPaymentDate).format("MMM-DD-YYYY"); }

		var pmtAmount = loan.secondPaymentAmount;

		// Organization Section
		var orgName = 'Essex Mortgage  Attn: Cashiering';
		var orgNameNoAttn = 'Essex Mortgage';

		var paymentUrl = 'https://EssexMortgage.com/MyAccount'
		var paymentPhone = '(888) 892-0881';
		var addressLine1 = '1417 N Magnolia Ave';
		var addressLine2 = 'Ocala, FL 34475';
		if (loan.servicedBy === 'CBC Mortgage Agency') {
			orgName = 'CBC Mortgage Agency Attn: Loan Servicing Payments:';
			orgNameNoAttn = 'CBC Mortgage Agency Attn: Loan Servicing Payments:';
			addressLine1 = '912 W Baxter Drive, Suite 150';
			addressLine2 = 'South Jordan, UT 84095';
			paymentPhone = '866-563-7572';
			paymentUrl = 'https://secure.gotobilling.com/gateway/transact.php?x_login=238575&x_show_form=PAYMENT_FORM';
		} else if (loan.servicedBy === 'Statebridge') {
			orgName = 'Statebridge';
			orgNameNoAttn = 'Statebridge';
			addressLine1 = 'P.O. Box 173313';
			addressLine2 = 'Denver, CO 80217-3313';
			paymentPhone = '(866) 466-3360';
			paymentUrl = 'http://www.statebridgecompany.com/make-a-payment/';
		} else if (loan.servicedBy === 'Midwest') {
			orgName = 'Midwest Loan Services';
			orgNameNoAttn = '';
			addressLine1 = 'P.O. Box 209';
			addressLine2 = 'Hancock, MI 49930';
			paymentPhone = '(800) 262-6574';
			paymentUrl = 'https://www.midwestloanservices.com';
		}

		/*
		var interestRate = "";

		if(!loan.status.includes("HFH")) {
			var dpaType = String(loan.dpaType || '');

			if (! dpaType) {interestRate = "N/A";}
			else if (dpaType.startsWith("10 year 0")) {interestRate =  "0%";}
			else if (dpaType.startsWith("30 year 5")) {interestRate =  "5%";}
			else if (dpaType.startsWith("10 year 6")) {interestRate =  "6%";}
			else if (dpaType.startsWith("10 Year 8")) {interestRate =  "8%";}
			else {interestRate = "N/A";}
		}*/

		displayBlock.push(<span key='1'>Your payment of <b>${pmtAmount}</b> is due to:<br /></span>);
		displayBlock.push(<span key='2'><b>{orgName}</b><br /><br /></span>);
		displayBlock.push(<span key='4'>Make your payment online <a href={paymentUrl}>here</a>.<br /><br /></span>);
		displayBlock.push(<span key='5'>Make your payment over the phone by calling<br />{paymentPhone}<br /><br /></span>);
		displayBlock.push(<span key='6'>Payment Mailing Address:<br />{addressLine1}<br />{addressLine2}<br /><br /></span>);
		displayBlock.push(<span key='7'>{orgNameNoAttn}<br />Customer Service {paymentPhone}<br /></span>);

	}

	return (
		<div>
			{displayBlock}
		</div>
	)
}

ReactDOM.render(<BorrowerLookupApp store={new BorrowerLookupStore()} />, document.getElementById('app'));
